import {Component, Injector, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ClaimService} from "../../../../services/claim.service";
import {Claim} from "../../../../model/claim.model";
import {ClaimsBaseComponent} from "../../../claim-base.component";
import {DatePipe} from "@angular/common";
import {DocumentField} from '../../../../model/document-field';
import {ClaimTypes} from '../../../../model/claim-type.model';
import {DocumentHelperService} from "../../../../services/document-helper.service";
import {DishonestyHelper} from "../../../../model/domestic-helper/dishonesty-helper.model";

@Component({
    selector: 'app-summary-dishonesty-helper',
    templateUrl: './summary-dishonesty-helper.component.html',
    styleUrls: ['./summary-dishonesty-helper.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SummaryDishonestyHelperComponent extends ClaimsBaseComponent implements OnInit {

    claim: Claim;
    dishonestyHelper: DishonestyHelper
    listOfDocuments: DocumentField[] = [];

    constructor(private claimService: ClaimService,
                private documentHelperService: DocumentHelperService,
                private injector : Injector) {

        super(injector);
        this.claim = this.claimService.getClaim();
        this.dishonestyHelper = this.claim.getClaimDomesticHelper().getDishonestyHelper();
        this.listOfDocuments = this.documentHelperService.getListOfDocuments(this.claimService.claim.getDocumentForm().documents,
            this.documentHelperService.getDocumentFormBuilder(ClaimTypes[ClaimTypes.CLAIM_TYPE_DMH_DISHONESTY]).getRequiredDocuments(),
            ClaimTypes[ClaimTypes.CLAIM_TYPE_DMH_DISHONESTY]);
    }
    
    ngOnInit() { }

    returnYesOrNo(value: string) {
        if ('Yes' === value) {
            return this.translate.instant("claimSection.generalLabels.radioButtonLabels.yes");
        } else {
            if ('No' === value) {
                return this.translate.instant("claimSection.generalLabels.radioButtonLabels.no");
            }
        }
        return '';
    }
    returnYesOrNoBoolean(value: boolean) {
        if (value) {
            return this.translate.instant("claimSection.generalLabels.radioButtonLabels.yes");
        } else {
            if (!value) {
                return this.translate.instant("claimSection.generalLabels.radioButtonLabels.no");
            }
        }
        return '';
    }

    getDate(dt: Date) {
        if (dt && dt != null) {
            return new DatePipe('en-US').transform(dt, "dd/MM/yyyy");
        }
        else {
            return "";
        }
    }

}
